<template>
    <Table
      :columns="cols"
      :data="tableData"
      :loading="loading"
      border
      :width="cols.reduce((a,v)=>a+v.width,0)+5"
      >
      <BaseLoading v-if="loading" />
      <div class="flex-wrap flex-right" style="font-size:12px;color:var(--subtext3)">

                  </div>
    </Table>
  </template>

<script>

import tableRender from '../../base/tableRender';
export default {
  name: 'CmTableYearInBuildingProjects',
  data() {
    return {
      tableData: [{
        dep: '公司',
      }, {
        dep: '建设管理事业部',
      }, {
        dep: '房建监理事业部',
      }, {
        dep: '市政监理事业部',
      }],
      loading: true,
    };
  },
  props: {
    year: {
      type: String | Number,
    },
  },
  computed: {
    cols() {
      return [{
        key: 'dep',
        title: '部门',
        align: 'center',
        width: 200,
      }, {
        key: 'total',
        title: '总计划竣工项目（项）',
        align: 'center',
        width: 200,
      }, {
        key: 'completed',
        title: '已经竣工项目（项）',
        align: 'center',
        width: 200,

      }, {
        key: 'to_complete',
        title: '尚可竣工项目（项）',
        align: 'center',
        width: 200,

      }];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api.get(`cm/tables/in_complete_projects?year=${this.year}`).then((res)=>{
        const result = res.data.data;
        this.tableData = result.data;
        this.created_at = result.created_at;
      }).finally(()=>{
        this.loading = false;
      });
    },
    exportExcel() {

    },
  },
};
</script>

  <style>

  </style>
